import styled, { css } from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 0 15px;
  };
`

export const TextImageWrapper = styled.div`
  display: flex;
  flex-flow: row;
  padding: 20px 0;
`

export const Title = styled.h4`
  font-size: 24px;
  margin-top: 0;
  color: ${colors.blue};
`

export const Image = styled.div`
  background-image: url(${ASSETS_PATH}/pages/Dashboard/images/girl-with-ipad.jpg);
  background-size: contain;
  background-repeat: no-repeat;
  min-width: 400px;
  height: 250px;
  margin-right: 60px;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    min-width: 250px;
    height: 156px;
  };
`
